<template>
  <div>
    <b-card>
      <b-card-body>
        <b-row>
          <b-col
          sm="12"
          md="3"
          >
            <div id="C5_C6" class="grafico_barras"></div>
          </b-col>

          <b-col
          sm="12"
          md="3"
          >
            <div id="A9" class="grafico_barras"></div>
          </b-col>

          <b-col
          sm="12"
          md="3"
          >
            <div id="B1" class="grafico_barras"></div>
          </b-col>

          <b-col
          sm="12"
          md="3"
          >
            <div id="ARENA_VERDE" class="grafico_barras"></div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body >
      <b-card-body>
        <b-row>
          <b-col
          sm="12"
          md="8"
          class="mt-2"
          >
            <b-form-group>
              <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="obtenerProgRiego"
              :disabled="loading"
              v-b-tooltip.hover.top="'Recargar Datos'"
              >
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
              </b-button>
              <b-button
              variant="gradient-primary"
              size="sm" class="mr-1"
              :disabled="downloadExcel"
              @click="descargarExcel()"
              v-b-tooltip.hover.top="'Descargar Excel'"
              >
                <font-awesome-icon v-if="downloadExcel" icon="fa-solid fa-arrows-rotate" spin />
                <font-awesome-icon v-else icon="fa-solid fa-download"/>
              </b-button>
              <!-- <b-button
              variant="gradient-primary"
              size="sm" class="mr-1"
              :disabled="downloadExcel"
              @click="descargarBD()"
              v-b-tooltip.hover.top="'Descargar BD'"
              >
                <font-awesome-icon v-if="downloadExcel" icon="fa-solid fa-arrows-rotate" spin />
                <font-awesome-icon v-else icon="fa-solid fa-database"/>
              </b-button> -->
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="2"
          >
            <b-form-group
              label="Año"
              label-for="anio"
            >
              <v-select
                  id="anio"
                  v-model="anio"
                  :options="anios"
                  @input="aplicarFiltros"
                  multiple
                  class="select-size-sm"
                  placeholder="Seleccionar semana..."
              />
            </b-form-group>
          </b-col>

          <b-col
            sm="12"
            md="2"
          >
            <b-form-group
              label="Semana"
              label-for="semana"
            >
              <v-select
                  id="semana"
                  v-model="semana"
                  :options="semanas"
                  @input="aplicarFiltros"
                  multiple
                  class="select-size-sm"
                  placeholder="Seleccionar semana..."
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body @contextmenu="mostrarEditadorColumnas">
      <b-table
        hover
        responsive
        small
        class="position-relative cont_tabla"
        sticky-header="58vh"
        :items="itemsFiltro"
        :fields="fields"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados."
        >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
  import * as am5 from '@amcharts/amcharts5';
  import * as am5xy from '@amcharts/amcharts5/xy';
  import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

  import axiosIns from '../../libs/axios'
  import vSelect from 'vue-select'
  import ToastificationContent from '@core/components/toastification/ToastificationContent'
  import Ripple from 'vue-ripple-directive'
  import { heightTransition } from '@core/mixins/ui/transition'
  import {
    BCard,
    BCardBody,
    BFormInput,
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BSpinner,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    VBTooltip,
    BTooltip,
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
  } from 'bootstrap-vue'

  // Función para obtener el número de semana ISO (estándar internacional)
  Date.prototype.getWeekNumber = function () {
      const d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      const weekNumber = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      return weekNumber;
  };

  // Obtener la fecha actual
  const fechaActual = new Date();
  // Obtener el número de semana ISO actual
  const numeroSemanaActual = fechaActual.getWeekNumber();

  export default {
    components: {
      BCard,
      BCardBody,
      BCol,
      BFormInput,
      BFormGroup,
      BRow,
      BTable,
      vSelect,
      BSpinner,
      BButton,
      BInputGroup,
      BInputGroupAppend,
      VBTooltip,
      BTooltip,
      BDropdown,
      BDropdownForm,
      BDropdownItem,
      BDropdownHeader,
      BDropdownDivider,
    },
    directives: {
      'b-tooltip': VBTooltip,
      Ripple,
    },
    mixins: [heightTransition],
    data: () => ({
      name:'Amchart',
      graficos: {
        "C5_C6": null,
        "A9": null,
        "B1": null,
        "ARENA_VERDE": null,
      },
      id_user: JSON.parse(localStorage.getItem('userData')).id,
      loading: false,
      items_completo:[],
      items: [],
      itemsFiltro: [],
      valoresPorAgrupar: ['etapa','producto'],
      etapa_filtro: [],
      fechas: [],
      etapa: [],
      etapas : [],
      columna:[],
      columnas:['CAMPO','TURNO','LOTE'],
      localSearch: null,
      downloadExcel:false,
      anio: [],
      anios: [],
      semana: [],
      semanas: [],
      empresa: ["AGROVISION PERÚ S.A.C"],
      empresas: [
        "AGROVISION PERÚ S.A.C",
        "ARENA VERDE",
      ],
      // cultivo: ['PALTA'],
      cultivo: [],
      // cultivos: [
      //   'ARANDANO','ESPARRAGO','PALTA','UVA', 'LIMON'
      // ],
      cultivos: [],
      // cultivos: [
      //   {text:"ARANDANO",value:"ARA"},
      //   {text:"ESPARRAGO",value:"ESP"}
      // ],
      version: [],
      versiones: [],
      fundos: [],
      fields:[
        {
          key: 'empresa',
          label: 'empresa',
          class: 'text-nowrap text-center sticky-column',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-2 alinear-medio',
          stickyColumn: true,
        },
        {
          key: 'fundo',
          label: 'fundo',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-2 alinear-medio',
        },
        {
          key: 'cultivo',
          label: 'cultivo',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-2 alinear-medio',
        },
        {
          key: 'etapa',
          label: 'etapa',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-2 alinear-medio',
        },
      ]
    }),
    computed: {},
    async mounted() {
      await this.obtenerProgRiego();
      // this.crearGrafico();
    },

    beforeDestroy() {
      if (root) {
        root.dispose();
      }
    },

    methods: {
      destruirGrafico(id) {
        if (this.graficos[id]) {
          this.graficos[id].root.dispose();
          this.graficos[id] = null;
        }
      },

      crearGrafico(id, parametros, titulo, color) {
        const yo = this
        // Destruir el gráfico existente si hay uno
        yo.destruirGrafico(id);

        am5.ready(function() {

          // Crear el elemento raíz de amCharts
          var root = am5.Root.new(id);

          // Guardar la referencia al gráfico
          yo.graficos[id] = {
            root: root,
            chart: null
          };

          // Set themes
          // https://www.amcharts.com/docs/v5/concepts/themes/
          root.setThemes([
            am5themes_Animated.new(root)
          ]);


          // Create chart
          // https://www.amcharts.com/docs/v5/charts/xy-chart/
          var chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            paddingLeft: 0,
            wheelX: "panX",
            wheelY: "zoomX",
            layout: root.verticalLayout
          }));

          // Add title
          var title = chart.children.unshift(am5.Label.new(root, {
            text: titulo, // Título del gráfico
            fontSize: 20,
            // fontWeight: "bold",
            textAlign: "center",
            x: am5.p50,
            centerX: am5.p50,
            paddingTop: 10,
            paadingBottom: 20,
            // fill: am5.color(0xff0000)
          }));

          // Add legend
          // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
          var legend = chart.children.push(
            am5.Legend.new(root, {
              centerX: am5.p50,
              x: am5.p50
            })
          );

        //   var data = [
        //   {
        //     "year": "2021",
        //     "europe": 2.5,
        //     "namerica": 2.5,
        //     "asia": 2.1,
        //     "lamerica": 1,
        //     "meast": 0.8,
        //     "africa": 0.4
        //   }, {
        //     "year": "2022",
        //     "europe": 2.6,
        //     "namerica": 2.7,
        //     "asia": 2.2,
        //     "lamerica": 0.5,
        //     "meast": 0.4,
        //     "africa": 0.3
        //   }, {
        //     "year": "2023",
        //     "europe": 2.8,
        //     "namerica": 2.9,
        //     "asia": 2.4,
        //     "lamerica": 0.3,
        //     "meast": 0.9,
        //     "africa": 0.5
        //   }
        // ]

        // let data = [
        //   {
        //     "year":"LUN",
        //     "min":2.5,
        //     "max":3.1
        //   },
        //   {
        //     "year":"MAR",
        //     "min":4,
        //     "max":5
        //   },
        //   {
        //     "year":"MIE",
        //     "min":2.5,
        //     "max":3.1
        //   },
        //   {
        //     "year":"JUE",
        //     "min":2.5,
        //     "max":3.1
        //   },
        //   {
        //     "year":"VIE",
        //     "min":5,
        //     "max":6
        //   },
        //   {
        //     "year":"SAB",
        //     "min":7,
        //     "max":8
        //   },
        //   {
        //     "year":"DOM",
        //     "min":9,
        //     "max":10
        //   }
        // ]

        let data = parametros

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        var xRenderer = am5xy.AxisRendererX.new(root, {
          cellStartLocation: 0.1,
          cellEndLocation: 0.9,
          minorGridEnabled: true,
          minGridDistance: 30,
        })

        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
          categoryField: "year",
          renderer: xRenderer,
          tooltip: am5.Tooltip.new(root, {})
        }));

        xRenderer.grid.template.setAll({
          location: 1
        })

        xAxis.data.setAll(data);

        // Rotar las etiquetas del eje X para mejorar la legibilidad
        xAxis.get("renderer").labels.template.setAll({
          rotation: -90, // Ajustar el ángulo de rotación según sea necesario
          centerY: am5.p50,
          centerX: am5.p100,
          fontSize: "12px" // Ajustar el tamaño de fuente si es necesario
        });

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
          renderer: am5xy.AxisRendererY.new(root, {
            strokeOpacity: 0.1
          })
        }));

        // Add series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        function makeSeries(name, fieldName,color) {
          var series = chart.series.push(am5xy.ColumnSeries.new(root, {
            name: name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: fieldName,
            categoryXField: "year"
          }));

          series.columns.template.setAll({
            tooltipText: "{name}, {categoryX}:{valueY}",
            width: am5.percent(90),
            tooltipY: 0,
            strokeOpacity: 0,
            fill: am5.color(color)
          });

          series.data.setAll(data);

          // Make stuff animate on load
          // https://www.amcharts.com/docs/v5/concepts/animations/
          series.appear();

          series.bullets.push(function () {
            return am5.Bullet.new(root, {
              locationY: 0.5,
              sprite: am5.Label.new(root, {
                text: "{valueY}",
                fill: root.interfaceColors.get("alternativeText"),
                centerY: am5.p50,
                centerX: am5.p50,
                populateText: true,
                rotation: -90,
                fontSize: "12px"
              })
            });
          });

          legend.data.push(series);
        }

        makeSeries("Total","total",color)

        // makeSeries("Europe", "europe");
        // makeSeries("North America", "namerica");
        // makeSeries("Asia", "asia");
        // makeSeries("Latin America", "lamerica");
        // makeSeries("Middle East", "meast");
        // makeSeries("Africa", "africa");


        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        chart.appear(1000, 100);

        }); // end am5.ready()
      },

      obtenerTotalesParaGraficos(){
        const yo = this

        // Objeto para almacenar los totales por fecha para cada fundo
        const totalesPorFecha = {
            "C5_C6": {},
            "A9": {},
            "B1": {},
            "ARENA_VERDE": {}
        };

        // Recorremos los elementos del array
        yo.itemsFiltro.forEach(item => {
            // Verificamos la empresa y el fundo
            if (item.empresa === "AGROVISION PERÚ S.A.C" && (item.fundo === "C5" || item.fundo === "C6")) {
               yo.sumarValoresPorFecha(totalesPorFecha["C5_C6"], item);
            } else if (item.empresa === "AGROVISION PERÚ S.A.C" && item.fundo === "A9") {
                yo.sumarValoresPorFecha(totalesPorFecha["A9"], item);
            } else if (item.empresa === "AGROVISION PERÚ S.A.C" && item.fundo === "B1") {
                yo.sumarValoresPorFecha(totalesPorFecha["B1"], item);
            } else if (item.empresa === "ARENA VERDE") {
                yo.sumarValoresPorFecha(totalesPorFecha["ARENA_VERDE"], item);
            }
        });

        // Objeto para almacenar los totales por fundo
        const totalesPorFundo = {
            "C5_C6": [],
            "A9": [],
            "B1": [],
            "ARENA_VERDE": []
        };

        // Recorremos el objeto totalesPorFecha
        Object.keys(totalesPorFecha).forEach(fundo => {
            // Recorremos las fechas y totales para cada fundo
            Object.keys(totalesPorFecha[fundo]).forEach(year => {
                // Creamos un objeto con la estructura deseada
                const nuevoItem = {
                    "year": year,
                    "total": totalesPorFecha[fundo][year]
                };
                // Agregamos el nuevo item a la lista correspondiente según el fundo
                totalesPorFundo[fundo].push(nuevoItem);
            });
        });


        yo.crearGrafico("C5_C6", totalesPorFundo['C5_C6'],"C5 - C6","#6BB545")
        yo.crearGrafico("A9", totalesPorFundo['A9'],"A9","#0F99D7")
        yo.crearGrafico("B1", totalesPorFundo['B1'],"B1","#C00D0D")
        yo.crearGrafico("ARENA_VERDE", totalesPorFundo['ARENA_VERDE'],"ARENA VERDE","#561651")

      },

      sumarValoresPorFecha(objeto, item){
        Object.keys(item).forEach(key => {
          if (key !== "cultivo" && key !== "empresa" && key !== "etapa" && key !== "fundo" && key !== "semana" && key !== "anio") {
              objeto[key] = (objeto[key] || 0) + item[key];
          }
        });
      },

      obtenerProgRiego(){
        const yo = this
        yo.loading = true
        const config = {
          method: 'get',
          url: '/pagricolas/riego/reporte_general/',
        }

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200){
              yo.items_completo = response.data['resultado'];
              yo.items = response.data['resultado'];
              yo.itemsFiltro = response.data['resultado'];
              // yo.items = yo.calcularCambios(response.data['resultado']);
              const fechas = new Set();
              // console.log(yo.items_completo)
              yo.items.forEach(item => {
                Object.keys(item).forEach(key => {
                    if (key.startsWith('20')) {
                      fechas.add(key);
                    }
                });

                if(!yo.anios.includes(item.anio)){
                  yo.anios.push(item.anio)
                }

                if(!yo.semanas.includes(item.semana)){
                  yo.semanas.push(item.semana)
                }

                if(!yo.cultivos.includes(item.cultivo)){
                  yo.cultivos.push(item.cultivo)
                }

                if(!yo.versiones.includes(item.version)){
                  yo.versiones.push(item.version)
                }

                if(!yo.fundos.includes(item.fundo)){
                  yo.fundos.push(item.fundo)
                }

              });

              let listaFechas = Array.from(fechas);
              yo.fechas = listaFechas

              for(let i of listaFechas){
                yo.fields.push(
                  {
                    key: i,
                    label: i,
                    class: 'text-nowrap text-center',
                    sortable: true,
                    tdClass: 'alinear-una-sola-linea',
                    thClass: 'py-0 alinear-medio',
                    formatter: (value, key, item) => {
                      // Redondea el valor a tres decimales antes de mostrarlo
                      return parseFloat(value).toFixed(2);
                    },
                  }
                )
              }

              // Comparacion entre fechas
              // const dynamicFields = listaDeSemanas.map(fecha => ({
              //   key: fecha,
              //   label: fecha,
              //   class: 'text-nowrap text-center',
              //   sortable: true,
              //   tdClass: 'alinear-una-sola-linea',
              //   thClass: 'py-0 alinear-medio',
              //   formatter: (value, key, item) => {
              //     const resultado = item[`${key}_cambio`];
              //     let icono = '';
              //     if (resultado === 'aumento') {
              //       icono = '▲'; // Flecha hacia arriba Unicode
              //     } else if (resultado === 'disminuyo') {
              //       icono = '▼'; // Flecha hacia abajo Unicode
              //     } else {
              //       icono = '—'; // Raya Unicode
              //     }
              //     return `${parseFloat(value).toFixed(2)} ${icono}`;
              //   },
              // }));

              //Creo los graficos
              yo.obtenerTotalesParaGraficos()
              // yo.crearGrafico("c5_c6", parametros_c5_c6,"C5 - C6")

            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.loading = false
          })
      },

      // calcularCambios(items) {
      //   return items.map(item => {
      //     const fechas = Object.keys(item).filter(key => key.startsWith('20')).sort();
      //     fechas.forEach((fecha, indice) => {
      //       if (indice === 0) {
      //         item[`${fecha}_cambio`] = 'sin-cambio';
      //       } else {
      //         const fechaAnterior = fechas[indice - 1];
      //         const valorActual = parseFloat(item[fecha]);
      //         const valorAnterior = parseFloat(item[fechaAnterior]);

      //         if (valorActual > valorAnterior) {
      //           item[`${fecha}_cambio`] = 'aumento';
      //         } else if (valorActual < valorAnterior) {
      //           item[`${fecha}_cambio`] = 'disminuyo';
      //         } else {
      //           item[`${fecha}_cambio`] = 'sin-cambio';
      //         }
      //       }
      //     });
      //     return item;
      //   });
      // },

      aplicarFiltros(){
        const yo = this

        if(yo.anio == null && yo.semana == null){
          console.log("VACIOS")
        }

        yo.itemsFiltrados = []
        let datosFiltrados = []
        // 1.-Realizo los filtros por Semana, Empresa, Cultivo
        datosFiltrados = yo.items_completo.filter(item => {
          // Verificar si todos los valores de cultivo, semana y empresa coinciden
          const anioCoincide = yo.anio.includes(item.anio);
          const semanaCoincide = yo.semana.includes(item.semana);
          // Si todos los valores coinciden, mantener el elemento
          return anioCoincide && semanaCoincide;
        })



        yo.itemsFiltro = datosFiltrados

        yo.obtenerTotalesParaGraficos()
      },

      obtenerInicioFinSemana(anio, numeroSemana) {
        const primerDiaDelAnio = new Date(anio, 0, 1);
        const ajusteDia = primerDiaDelAnio.getDay() - 1;
        const primerDia = new Date(anio, 0, 1 + (numeroSemana - 1) * 7 - ajusteDia);
        const ultimoDia = new Date(anio, 0, primerDia.getDate() + 6);

        // Formateo de las fechas a YYYY-MM-DD
        const fechaInicio = primerDia.toISOString().split('T')[0];
        const fechaFin = ultimoDia.toISOString().split('T')[0];

        return {
          fechaInicio,
          fechaFin
        };
      },

      mostrarEditadorColumnas(event){
        event.preventDefault(); // Prevenir el menú contextual del navegador
        if (event.button === 2) { // 2 es el código para el botón derecho del mouse
          console.log("HOLA")
        }
      },

      editarColumnas(){
        const yo = this
        // Reinicio los valors por agrupar y los fields
        yo.valoresPorAgrupar = ['etapa','producto']
        let cols_a_eliminar = ['campo','turno','lote']
        for (var i = yo.fields.length - 1; i >= 0; i--) {
          if (cols_a_eliminar.includes(yo.fields[i].key)) {
              yo.fields.splice(i, 1);
          }
        }

        for(let c of yo.columna){
          yo.valoresPorAgrupar.push(c.toLowerCase())

          let nuevoObjeto = {
            key: c.toLowerCase(),
            label: c.toLowerCase(),
            class: 'text-nowrap text-center',
            sortable: true,
          }
          var existe = yo.fields.some(function(obj) {
            return obj.key === nuevoObjeto.key;
          });

          if (!existe) {
            yo.fields.splice(1, 0, nuevoObjeto);
          } else {
            console.log("Ya existe un objeto con el mismo key.");
          }
        }
        // Vuelvo a Filtrar por la nueva actualización de columnas
        this.aplicarFiltros()
      },

      aplicarBusqLocal(accion){
        const yo = this
        console.log("Busqueda Local")
        console.log(yo.localSearch)
        let busqueda = yo.localSearch

        if(accion == false){
          yo.localSearch = ''
          this.aplicarFiltros()
        }

        if(busqueda == '' || busqueda == null){
          yo.localSearch = ''
          this.aplicarFiltros()
        }else{
          let resultadoFiltro = []
          resultadoFiltro = yo.itemsFiltro.filter(item =>
            item.producto.includes(busqueda)
          );
          yo.itemsFiltro = resultadoFiltro
        }
      },

      descargarExcel(){
        const yo = this
        console.log(yo.itemsFiltro)
        let datos=[]
        const data = JSON.stringify(
          {
            "datas": yo.items,
            "id_user": yo.id_user,
            "fechas": yo.fechas,
          }
        )
        const config = {
          method: 'post',
          url: '/pagricolas/riego/reporte/exportar/reporte_general/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "Exportar detalle fertilizacion.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
              {
                position: 'top-center',
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingSAD = false
            yo.loadingSSD = false
          });
      },

      descargarBD(){
        const yo = this
        console.log(yo.itemsFiltro)
        let datos=[]
        const data = JSON.stringify(
          {
            "datas": yo.itemsFiltro,
            "id_user": yo.id_user
          }
        )
        const config = {
          method: 'post',
          url: '/pagricolas/riego/reporte/exportar/reporte_general/all/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "Exportar detalle fertilizacion.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
              {
                position: 'top-center',
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingSAD = false
            yo.loadingSSD = false
          });
      },

      filtradoPorColumna(){
        const yo = this
        let spd = yo.itemsResumen

        let filt = []
        let c = 0

        for (const valor of yo.filtro) {
          if (valor.nombre === cabecera) {
            yo.filtro[c].valor = data
          }

          c += 1;
        }
        // console.log(yo.filtro)
        for (const values of yo.filtro) {
          for (const column of values.valor) {
            spd.forEach(function (value) {
              if (column === 'VACIOS') {
                if (value[values.nombre] === null || value[values.nombre] === '' || value[values.nombre] === ' ' || value[values.nombre] === '  ') {
                  filt.push(value)
                }
              } else {
                // console.log(values.nombre)
                if (value[values.nombre] === column) {
                  filt.push(value)
                }
              }
            })
          }

          if (values.valor.length > 0) {
            if (values.valor[0] !== null) {
              spd = filt
              filt = []
            }
          }
        }

        yo.itemsFiltro = spd
      },

      mostrarNotificacion(titulo, icono, texto, variante, tiempo){
        this.$toast({
              component: ToastificationContent,
              props:{
                title: titulo,
                icon: icono,
                text: texto,
                variant: variante
              }
            },
            {
              timeout: tiempo,
              position: 'top-center',
            })
      },

    },

  }
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .cont_tabla{
    min-height: 400px;
    max-height: 900;
  }

  .alinear-una-sola-linea {
    white-space: nowrap !important;
  }

  .alinear-medio {
    vertical-align: middle !important;
  }

  .sticky-column {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  .grafico_barras {
    width: 100%;
    height: 400px;
  }

</style>
